const prod = process.env.NODE_ENV !== "development";
let gatewayUrl = process.env.REACT_APP_GATEWAY_URL;
let accountUrl = process.env.REACT_APP_ACCOUNT_URL;
let authUrl = process.env.REACT_APP_AUTH_URL;
let defaultUrl = process.env.REACT_APP_DEFAULT_REDIRECT_URI;
if(prod){
    gatewayUrl = "https://" + document.domain.replace("id.", "gateway.");
    authUrl = "https://" + document.domain.replace("id.", "auth.");
    accountUrl = "https://" + document.domain;
    defaultUrl = "https://" + document.domain.replace("id.", "");
  }

// Dev fallback: when the SPA is loaded from an IP or localhost there is no
// `id.<env>` / `gateway.<env>` DNS, and any URL baked in at build time is
// only valid for one specific host. Mirror prod shape (account ở `id.<env>`
// gọi thẳng `gateway.<env>`, không qua reverse-proxy) bằng cách gọi gateway
// trên host port riêng (18088 trong tqb-dev compose), cùng host trình duyệt.
const ipv4Re = /^(?:(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/;
const browserHostname = typeof window !== "undefined" ? window.location.hostname : "";
if (browserHostname === "localhost" || browserHostname === "127.0.0.1" || ipv4Re.test(browserHostname)) {
  gatewayUrl = `${window.location.protocol}//${browserHostname}:18088`;
}

export const GATEWAY_URL = gatewayUrl;
export const AUTH_URL = authUrl;

export const ACCESS_TOKEN = 'accessToken';

export const DEFAULT_REDIRECT_URI = defaultUrl;
export const OAUTH2_REDIRECT_URI = accountUrl + '/oauth2/redirect'

export const GOOGLE_AUTH_URL = AUTH_URL + '/api/oauth2/authorize/google?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const FACEBOOK_AUTH_URL = AUTH_URL + '/api/oauth2/authorize/facebook?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const GITHUB_AUTH_URL = AUTH_URL + '/api/oauth2/authorize/github?redirect_uri=' + OAUTH2_REDIRECT_URI;

// Asset preloading constants
export const MAINFE_URL = defaultUrl || 'https://tqb.edu.vn';
export const TQB_APP_URL = process.env.REACT_APP_TQB_APP_URL || (prod
  ? `https://app.${document.domain.replace('id.', '')}`
  : 'https://app.tqb.edu.vn');
export const DRIVE_APP_URL = process.env.REACT_APP_DRIVE_APP_URL || (prod
  ? `https://drive.${document.domain.replace('id.', '')}`
  : 'https://drive.tqb.edu.vn');
export const H5PCLIENT_URL = process.env.REACT_APP_H5PCLIENT_URL || (prod
  ? `https://h5pclient.${document.domain.replace('id.', '')}`
  : 'https://h5pclient.tqb.edu.vn');
export const BUILD_INFO_ENDPOINT = '/build_info.json';
